export const MODULE_URL = 'https://static.parastorage.com/unpkg'
export const TPA_COMPONENTS = ['TPASection', 'TPAMultiSection', 'TPAWidget']
